import properties from '../modules/ajio-util/properties';

export function getCookieConfig({
  expiryTime = Date.now() + 3600 * 1000,
  secure = false,
  httpOnly = false,
  cookieName = '',
  expires,
  req = {},
  path,
  sameSite = false
}) {
  let defaultSetting = {
    httpOnly,
    maxAge: expiryTime,
    secure,
    path
  };
  if (expires != undefined) {
    delete defaultSetting.maxAge;
    defaultSetting = { ...defaultSetting, expires };
  }

  const { headers: { origin = '', host = '', referer = '' } = {} } = req;
  const domainToBeUSed = path || getDomain(origin, host, referer);
  // let xForwardedHost = req.headers["x-forwarded-host"];
  if (domainToBeUSed) {
    defaultSetting = { ...defaultSetting, domain: domainToBeUSed };
  }

  // Set Secure flag for all environments except localhost
  const isLocalhost = host?.includes('localhost') || origin?.includes('localhost') || referer?.includes('localhost');
  if (!isLocalhost) {
    defaultSetting = { ...defaultSetting, secure: true };
  }
  
  if (cookieName === 'A' && process.env.NODE_ENV.toLowerCase() !== 'production') {
    defaultSetting = { ...defaultSetting, expiryTime: 70000 };
  }
  if (sameSite) {
    defaultSetting = {
      ...defaultSetting,
      sameSite: 'none'
    };
  }
  return defaultSetting;
}

export function clearCookieConfig(req = {}) {
  let defaultSetting = {};
  const { headers: { origin = '', host = '', referer = '' } = {} } = req;
  const domainToBeUSed = getDomain(origin, host, referer);
  if (domainToBeUSed) {
    defaultSetting = { ...defaultSetting, domain: `.${domainToBeUSed}`, path: '/' };
  }
  return defaultSetting;
}

export function getDomain(origin, host, referer) {
  const domainArr = ['ril.com', 'ajio.com', 'jio.com'];
  const isDev = process.env.NODE_ENV === 'development';
  for (let i = 0; i < domainArr.length; i++) {
    const domainToBeUSed = domainArr[i];
    if (
      (origin && origin.toLowerCase().includes(domainToBeUSed)) ||
      (host && host.toLowerCase().includes(domainToBeUSed)) ||
      (referer && referer.toLowerCase().includes(domainToBeUSed))
    ) {
      return domainToBeUSed;
    }
  }
  if (isDev) {
    return '';
  }
  return 'ajio.com';
}
